import { createReducer, on } from '@ngrx/store';
import { Payment } from 'src/app/models/payments.model';
import * as fromPaymentsActions from '../actions/payments.actions';

export interface PaymentsState {
  data: Payment[];
  loaded: boolean;
  loading: boolean;
  error: string;
  selectedPaymentId: string;
}

export const initialState: PaymentsState = {
  data: undefined as any,
  loaded: false,
  loading: false,
  error: '',
  selectedPaymentId: ''
};

export const paymentsReducer = createReducer(
  initialState,
  on(fromPaymentsActions.LoadPaymentsAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromPaymentsActions.LoadPaymentsSuccessAction, (state, { data }) => ({
    ...state,
    data,
    loaded: true,
    loading: false
  })),
  on(fromPaymentsActions.LoadPaymentsFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromPaymentsActions.SelectPaymentAction, (state, { paymentId }) => ({
    ...state,
    selectedPaymentId: paymentId
  })),
  on(fromPaymentsActions.UnselectPaymentAction, (state) => ({
    ...state,
    selectedPaymentId: ''
  }))
);
